import { render, staticRenderFns } from "./caches-list.vue?vue&type=template&id=55713c67&"
import script from "./caches-list.vue?vue&type=script&lang=js&"
export * from "./caches-list.vue?vue&type=script&lang=js&"
import style0 from "./caches-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports